module.exports = require("././angular-animate.js");


//////////////////
// WEBPACK FOOTER
// angular-animate (bower component)
// module id = 455
// module chunks = 1